"use client";

import React from "react";
import { BannerImage } from "@/app/components/MoveBrasil/BannerImage";
import { MOVE_BRASIL_CONDITIONS } from "@/app/config/moveBrasil";
import styles from "@/styles/move-brasil.module.scss";

export const ConditionsSection: React.FC = () => {
	return (
		<section className={styles.conditions}>
			<h2 className={styles.conditionsTitle}>
				As melhores condições do mercado
			</h2>
			<div className={styles.conditionsGrid}>
				{MOVE_BRASIL_CONDITIONS.map((item) => (
					<article key={item.title} className={styles.benefitItem}>
						<figure className={styles.benefitIconWrap}>
							<BannerImage
								src={item.icon}
								alt={item.title}
								className={styles.benefitIcon}
								fallbackClassName={styles.benefitIconFallback}
							/>
						</figure>
						<div className={styles.benefitBody}>
							<h3 className={styles.benefitTitle}>{item.title}</h3>
							<div className={styles.benefitAccent} aria-hidden="true" />
							<p className={styles.benefitText}>{item.description}</p>
						</div>
					</article>
				))}
			</div>
		</section>
	);
};
